import React from 'react';

export default () => {
  return (
    <div className="step row">
      {/*Pregunta 37*/}
      <div className="col-md-12">
        <h3>
          37. ¿No me preocupa perder mi trabajo en los próximos seis meses?
        </h3>
        <ul className="data-list-2" id="preg37">
          <li>
            <input
              name="preg37"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg37"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg37"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg37"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg37"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 38*/}
      <div className="col-md-12">
        <h3>38. ¿Me siento seguro de mi trabajo, aún si cometo un error?</h3>
        <ul className="data-list-2" id="preg38">
          <li>
            <input
              name="preg38"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg38"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg38"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg38"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg38"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 39*/}
      <div className="col-md-12">
        <h3>
          39. ¿Puedo estar en desacuerdo con mi jefe inmediato sin temor a
          meterme en problemas?{' '}
        </h3>
        <ul className="data-list-2" id="preg39">
          <li>
            <input
              name="preg39"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg39"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg39"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg39"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg39"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 40*/}
      <div className="col-md-12">
        <h3>40. ¿Recibo apoyo de otras personas cuando lo necesito?</h3>
        <ul className="data-list-2" id="preg40">
          <li>
            <input
              name="preg40"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg40"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg40"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg40"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg40"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Step10.jsx